import {
  Component,
} from "react";
import {
  Button,
  Navbar,
} from "react-bootstrap";
import {
  withLocation,
} from "CommonCore/router-util";

import store from "CommonState/store";
import {
  Awesome,
  Tooltip,
} from "CommonComponents/bricks";
import TipLink from "Components/tip-link";

import {
  formatDate,
} from "CommonCore/l10n";
import SearchBar from "Components/search-bar";
import {
  ANTRAGSTELLERMODUS,
} from "App/constants";


@withLocation
class ProfilButton extends Component {
  render() {
    return (
      <span className='topbar-icon-block'>
        <a onClick={this.showProfil}>
          <Tooltip overlay='Profil bearbeiten'>
            <Awesome name='user' className='icon-only' />
          </Tooltip>
        </a>
      </span>
    );
  }
  showProfil = () => {
    this.props.history.push("/profil");
  };
}


@store("user", "flag_antragstellermodus")
@withLocation
export default class DashboardTopbar extends Component {
  render() {
    const {
      user: { name = "Unknown", vorname = "", letzte_login },
      flag_antragstellermodus,
    } = this.props;

    return <Navbar variant='default'>
      <Navbar.Collapse>
        <div className='navbar-form'>
          <Tooltip overlay='Menü verkleineren/erweitern'>
            <Button variant='outline-primary' onClick={this.props.toggleDashboardMenu}>&nbsp;<Awesome name='bars' />&nbsp;</Button>
          </Tooltip>
        </div>
        <div className='navbar-form me-auto'>
          <strong className='font-bold'>Herzlich willkommen, {vorname} {name}</strong>
          <br />
          Letzte Anmeldung: {letzte_login ? formatDate(letzte_login * 1000) : "nie"}
        </div>
        <div className='navbar-form me-auto'>
          <TipLink overlay='Sie können Ihr Ziel für das e-Portal auf der Startseite ändern' to='/'><h4>{flag_antragstellermodus && ANTRAGSTELLERMODUS[flag_antragstellermodus].label}</h4></TipLink>
        </div>
        <div className='navbar-form ms-auto'>
          <SearchBar />
          <Button variant='outline-primary' onClick={this.logout}>Abmelden</Button>
          <ProfilButton />
        </div>
      </Navbar.Collapse>
    </Navbar>;
  }

  logout = () => {
    this.props.logout();
    this.props.history.push("/");
  };
}
